import React, { Children } from 'react';
import { motion } from 'framer-motion';
// Each chunk lands at the same final position (x:0, y:0, blur:0, rotate:0).
// Initial state defines WHERE it comes flying in from.
const titleChunks = [{
  text: 'Tu',
  from: {
    x: -300,
    y: -120,
    rotate: -15
  }
}, {
  text: 'competencia',
  from: {
    x: 200,
    y: -200,
    rotate: 8
  }
}, {
  text: 'ya',
  from: {
    x: -250,
    y: 180,
    rotate: 12
  }
}, {
  text: 'está',
  from: {
    x: 280,
    y: 220,
    rotate: -10
  }
}, {
  text: 'online.',
  from: {
    x: 0,
    y: 280,
    rotate: 5
  }
}];
const subtitleChunks = [{
  text: 'Activá hoy una web premium',
  from: {
    x: -200,
    y: 0
  }
}, {
  text: 'y hacé que tu negocio se vea',
  from: {
    x: 200,
    y: 0
  }
}, {
  text: 'tan profesional como realmente es.',
  from: {
    y: 80,
    x: 0
  }
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18,
      delayChildren: 0.1
    }
  }
};
const subContainerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
      delayChildren: 1.3 // start after title finishes
    }
  }
};
export function FinalCTA() {
  return <section className="py-24 md:py-40 relative overflow-hidden flex items-center justify-center min-h-[70vh] md:min-h-[80vh]" data-id="element-112">
      {/* Subtle starfield, no big orbs */}
      <div className="absolute inset-0 z-0 opacity-50 pointer-events-none" data-id="element-113">
        {[...Array(25)].map((_, i) => <div key={i} className="absolute w-1 h-1 bg-white rounded-full animate-slow-float" style={{
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 5}s`,
        opacity: Math.random() * 0.5 + 0.2
      }} data-id="element-114"></div>)}
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-115">
        {/* Title — words fly in from different directions and assemble in the center */}
        <motion.h2 variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className="text-5xl sm:text-6xl md:text-8xl font-bold tracking-tighter text-white mb-6 md:mb-8 drop-shadow-2xl flex flex-wrap items-center justify-center gap-x-3 sm:gap-x-4 gap-y-2 leading-[1.05]" data-id="element-116">
          {titleChunks.map((chunk, i) => <motion.span key={i} variants={{
          hidden: {
            opacity: 0,
            x: chunk.from.x,
            y: chunk.from.y,
            rotate: chunk.from.rotate,
            filter: 'blur(20px)',
            scale: 0.6
          },
          visible: {
            opacity: 1,
            x: 0,
            y: 0,
            rotate: 0,
            filter: 'blur(0px)',
            scale: 1,
            transition: {
              duration: 0.9,
              ease: [0.22, 1, 0.36, 1]
            }
          }
        }} className="inline-block will-change-transform" data-id="element-117">
              {chunk.text}
            </motion.span>)}
        </motion.h2>

        {/* Subtitle — chunks materialize from different sides */}
        <motion.p variants={subContainerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className="text-xl md:text-2xl text-neutral-300 font-light mb-12 max-w-2xl mx-auto flex flex-wrap items-center justify-center gap-x-2 gap-y-1 leading-relaxed" data-id="element-118">
          {subtitleChunks.map((chunk, i) => <motion.span key={i} variants={{
          hidden: {
            opacity: 0,
            x: chunk.from.x,
            y: chunk.from.y,
            filter: 'blur(12px)'
          },
          visible: {
            opacity: 1,
            x: 0,
            y: 0,
            filter: 'blur(0px)',
            transition: {
              duration: 0.8,
              ease: [0.22, 1, 0.36, 1]
            }
          }
        }} className="inline-block will-change-transform" data-id="element-119">
              {chunk.text}
            </motion.span>)}
        </motion.p>

        {/* Button — materializes from nothing, last */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.2,
        filter: 'blur(24px)'
      }} whileInView={{
        opacity: 1,
        scale: 1,
        filter: 'blur(0px)'
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1,
        delay: 2.4,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-120">
          <a href="https://wa.me/59898838657?text=%C2%A1Hola%21%20Quiero%20activar%20mi%20web%20premium%20con%20WebsiteIA.%20%C2%BFMe%20asesoran%3F" target="_blank" rel="noreferrer" className="relative inline-flex items-center justify-center px-10 py-5 text-lg font-bold text-white transition-all duration-300 bg-white/10 border border-white/20 rounded-full hover:bg-white/20 hover:scale-105 group overflow-hidden shadow-[0_0_40px_rgba(168,85,247,0.4)]" data-id="element-121">
            <span className="relative z-10" data-id="element-122">Quiero mi web ahora</span>
            <div className="absolute inset-0 bg-gradient-to-r from-electric to-cyan opacity-0 group-hover:opacity-30 transition-opacity duration-300" data-id="element-123"></div>
          </a>
        </motion.div>
      </div>
    </section>;
}